module.exports = __webpack_public_path__ + "img/stak.f5991d3a.svg";